module.exports = __webpack_public_path__ + "img/ziguang.daa17d15.png";